import { render, staticRenderFns } from "./BB-analysing.vue?vue&type=template&id=e8e7773c&"
import script from "./BB-analysing.vue?vue&type=script&lang=js&"
export * from "./BB-analysing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports